/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathPi = createReactComponent("math-pi", "IconMathPi", [
  ["path", { d: "M7 20v-16", key: "svg-0" }],
  ["path", { d: "M17 4v16", key: "svg-1" }],
  ["path", { d: "M20 4h-16", key: "svg-2" }]
]);

export { IconMathPi as default };
//# sourceMappingURL=IconMathPi.js.map
